import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import constructionOfSeqDatasetComponent from '../components/constructionOfSeqDatasetComponent';
import IAppState from '../../../IAppState';
import ActMain from '../../../act-main';
import ActSummary from '../../SummaryPage/state/act-summary';
import { clientUrlPrefix } from '../../../settings';
import {
    IConstructionOfSeqDatasetPropsData,
    IConstructionOfSeqDatasetPropsFunctions,
} from '../props/IConstructionOfSeqDatasetProps';

interface IOwnProps {
    ecNumber?: string;
    choice;
    customQuery?: boolean;
    history: any;
}

const mapStateToProps = (
    { mainState }: IAppState,
    ownProps: IOwnProps
): IConstructionOfSeqDatasetPropsData => {
    return {

        ...mainState,
        maxNumSeqField : mainState.advancedOptions.maxNumSeqField,
        blastEvalField: mainState.advancedOptions.blastEvalField,
        minIdentityField: mainState.advancedOptions.minIdentityField,
        maxIdentityField: mainState.advancedOptions.maxIdentityField,
    };
};

const mapDispatchToProps = (
    dispatch: any,
    ownProps: IOwnProps
): IConstructionOfSeqDatasetPropsFunctions => ({
    
    changemaxNumSeqField: (maxNumSeqField: number ) => dispatch(ActMain.changemaxNumSeqField(maxNumSeqField)),
    changeblastEvalField : (blastEvalField: number ) => dispatch(ActMain.changeblastEvalField (blastEvalField)),
    changeminIdentityField : (minIdentityField: number ) => dispatch(ActMain.changeminIdentityField(minIdentityField)),
    changemaxIdentityField : (maxIdentityField: number ) => dispatch(ActMain.changemaxIdentityField(maxIdentityField)),
});

const ConstructionOfSeqDatasetContainer = withRouter(
    connect(mapStateToProps, mapDispatchToProps)(constructionOfSeqDatasetComponent)
);
export default ConstructionOfSeqDatasetContainer;
